/**
 * PlanBoard slice.
 *
 * Plan page state — card placements, ordering, drawn lines, axis labels, zoom
 * and connections. Shared across every OST in a project.
 *
 * Slices share one store: `set` and `get` are typed over the whole AppStore,
 * so an action here can read or write another slice's state where the domains
 * genuinely interact (loading a project resets the tree, converting a triage
 * item calls the tree's addNode).
 */
import type { StateCreator } from 'zustand';
import type { EnablerCardItem, PlanAxisLabel, PlanBoardConnection, PlanCardPlacement, PlanDrawnLine } from '../../types';
import type { AppStore } from '../storeTypes';

export const createPlanBoardSlice: StateCreator<
    AppStore,
    [],
    [],
    Pick<
        AppStore,
        | 'planPlacements'
        | 'planOrder'
        | 'planLines'
        | 'planAxisLabels'
        | 'planZoom'
        | 'planConnections'
        | 'planEnablerCards'
        | 'setPlanBoardData'
    >
> = (set, get) => ({
    planPlacements: {},

    planOrder: [],
    planLines: [],
    planAxisLabels: [],
    planZoom: undefined,
    planConnections: [],
    planEnablerCards: [],

    setPlanBoardData: (data: { placements: Record<string, PlanCardPlacement>; order: string[]; lines?: PlanDrawnLine[]; axisLabels?: PlanAxisLabel[]; zoom?: number; connections?: PlanBoardConnection[]; enablerCards?: EnablerCardItem[] }) => {
        set({
            planPlacements: data.placements || {},
            planOrder: data.order || [],
            planLines: data.lines || [],
            planAxisLabels: data.axisLabels || [],
            planZoom: data.zoom,
            planConnections: data.connections || [],
            planEnablerCards: data.enablerCards || [],
        });
    },
});
